import React from 'react'
import { withTranslation } from "react-i18next";
import { Avatar } from 'antd';

const Image = (props) => {
  const { t } = props;

  return (<div style={{display: 'inline-block',
    position: 'relative'}}>
     <img shape="square" src={props.src} style={{verticalAlign: 'middle',width: '100%',height: 'auto' }}/>   

     </div>                                              
  )
};

export default withTranslation()(Image);

